import React from 'react';

import { t } from '@lingui/macro';
import { useNavigate } from 'react-router-dom';

import { Button } from '@olist/design-system';

import { PageLayout } from 'components';
import { ButtonWrapper, Logos, Title } from 'components/general';
import { OlistChecked } from 'components/icons/appLogos';
import useMixPanel from 'hooks/use-mixpanel';

export default function ResetPasswordSuccess() {
  const navigate = useNavigate();
  const { track } = useMixPanel(false);

  return (
    <PageLayout>
      <section>
        <Logos>
          <OlistChecked />
        </Logos>
        <Title>{t`new password changed successfully`}</Title>
        <ButtonWrapper>
          <Button
            fixed
            variation="primary"
            size="medium"
            onClick={() => {
              track('Reset Password Success - Clicked on Return to Login');
              navigate('/auth/login');
            }}
            className="button"
          >
            {t`access platform`}
          </Button>
        </ButtonWrapper>
      </section>
    </PageLayout>
  );
}
